import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  withStyles,
  Grid,
  FormHelperText,
  IconButton,
  Hidden,
} from '@material-ui/core'
import conversationItemTypes from './conversationItemTypes'
import AvatarWithLabel from '../AvatarWithLabel'
import afinn from 'afinn-165'
import { words, startCase } from 'lodash'
import moment from 'moment'
// import contactLabel from 'utils/contactLabel'
import inboxItemLabels from 'utils/inboxItemLabels'
import Link from 'utils/Link'
import { AttachFile } from '@material-ui/icons'
import Linkify from 'linkify-react'
import { openImageDialog } from 'actions/view'
import Button from 'components/theme/Button'
import DudeReadingV2Icon from 'components/theme/DudeReadingV2Icon'
import { generateInboxResponse } from 'actions/InboxAI/generateInboxResponse'
import { toggleDialog } from 'actions/view'
import { deleteEntity } from 'actions/data'
import openAiAllowedAccountIDs from 'utils/openAiAllowedAccountIDs'
import RetrySend from './RetrySend'
import { DATA_API_URL } from 'utils/AllURLs'

const urlParams = new URLSearchParams(window.location.search)
const jwtToken = urlParams.get('jwtToken')

const styles = theme => ({
  threadItemContainer: {
    padding: '10px 20px 10px 60px',
    position: 'relative',
  },
  threadItem: {
    backgroundColor: '#f1f1f1',
    padding: '43px 16px 23px 62px',
    borderRadius: 13,
    position: 'relative',
    minHeight: 64,
  },
  avatar: {
    position: 'absolute',
    top: 12,
    left: 12,
  },
  iconContainer: {
    position: 'absolute',
    top: '50%',
    left: 14,
    transform: 'translate(0, -50%)',
    textAlign: 'center',
  },
  icon: {
    fill: '#c2c2c2',
    fontSize: 30,
  },
  iconLabel: {
    fontSize: 10,
    color: '#c2c2c2',
    marginTop: '-4px',
  },
})

const devOrProd =
  window?.location?.href?.slice?.(0, 29) === 'https://console.vastreach.com'
    ? 'Prod'
    : 'Dev'

const SMSItem = ({
  classes,
  key,
  conversationItem,
  contact,
  businessName,
  accountName,
  openImageDialog,
  generateInboxResponse,
  toggleDialog,
  openaiinboxresponseID,
  deleteEntity,
  vr_account_id,
  index,
}) => {
  const conversationItemType = conversationItem && conversationItem.type
  const sms = conversationItemType && conversationItem[conversationItemType]
  const type =
    conversationItemTypes && conversationItemTypes[conversationItemType]
  const Icon = type && type.icon
  const status = sms && sms.status

  const score =
    sms && sms.body
      ? words(sms.body).reduce((sum, word) => {
          sum += afinn[word] || 0
          return sum
        }, 0)
      : 0

  if (!sms) return null

  const toggleAndSend = () => {
    toggleDialog({
      open: true,
      dialog: 'InboxAiResponse',
      options: {
        to: sms?.originator_number,
      },
    })
    generateInboxResponse({
      conversationItem,
      index,
      type: 'generateSmsResponse',
    })
  }

  const onClick = () => {
    if (openaiinboxresponseID) {
      deleteEntity(
        openaiinboxresponseID,
        'openaiinboxresponse',
        `${DATA_API_URL}/openaiinboxresponse/${openaiinboxresponseID}`,
        'none',
      ).then(() => toggleAndSend())
    } else {
      toggleAndSend()
    }
  }

  return (
    <div key={key} className={classes.threadItemContainer}>
      <div className={classes.iconContainer}>
        <Icon className={classes.icon} />
        <div className={classes.iconLabel}>
          {conversationItemTypes[conversationItem.type].label}
        </div>
      </div>
      <div className={classes.threadItem}>
        <div className={classes.avatar}>
          <AvatarWithLabel
            type={conversationItem.direction === 'inbound' ? 'contact' : 'user'}
            contact={contact}
            label={inboxItemLabels({
              itemType: 'sms',
              item: conversationItem,
              businessName,
              accountName,
              contact,
            })}
          />
          {/* {conversationItem.type} */}
        </div>
        <Grid
          justify="center"
          direction="column"
          container
          alignItems="flex-start"
          style={{
            fontSize: 14,
            minHeight: 52,
          }}
        >
          <Grid item style={{ maxWidth: '100%' }}>
            <div style={{ wordWrap: 'break-word', hyphens: 'auto' }}>
              <Linkify
                options={{
                  attributes: {
                    onClick: event => {
                      console.log('event', event.target.href)
                      const confirmMessage =
                        'Would you like to open this link? Beware of links from unknown sources'
                      if (jwtToken) {
                        event.preventDefault()
                        if (window.confirm(confirmMessage))
                          window.ReactNativeWebView.postMessage(
                            event.target.href,
                          )
                      } else if (!window.confirm(confirmMessage)) {
                        event.preventDefault()
                      }
                    },
                    target: '_blank',
                  },
                }}
              >
                {conversationItem?.[conversationItem?.type]?.body}
              </Linkify>
            </div>
            {conversationItem?.[conversationItem?.type]?.attachments?.map?.(
              (attachment, idx) => {
                const indexOfImage = attachment?.content_type
                  ?.toLowerCase?.()
                  ?.indexOf?.('image')

                return (
                  <div>
                    {indexOfImage >= 0 ? (
                      <div style={{ height: 350, position: 'relative' }}>
                        <img
                          onClick={() => openImageDialog(attachment?.url)}
                          alt="attachment"
                          style={{
                            maxWidth: '100%',
                            maxHeight: 350,
                            cursor: 'pointer',
                            // position: 'absolute',
                            // top: '50%',
                            // transform: 'translate(-50%, 0)',
                          }}
                          src={attachment?.url}
                        />
                      </div>
                    ) : (
                      <Link download href={attachment?.url}>
                        <AttachFile style={{ fontSize: 14 }} /> Attachment
                        {idx + 1}
                      </Link>
                    )}
                  </div>
                )
              },
            )}
          </Grid>
        </Grid>
      </div>
      <div
        style={{
          position: 'absolute',
          top: 15,
          left: 122,
          fontSize: 14,
          width: 'calc(100% - 160px)',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        <span style={{ fontWeight: 'bold' }}>
          {inboxItemLabels({
            itemType: 'sms',
            item: conversationItem,
            businessName,
            accountName,
            contact,
          })}
        </span>
        {score > 0 ? (
          <span style={{ color: 'green', marginLeft: 15 }}>☺</span>
        ) : score < 0 ? (
          <span style={{ color: 'red', marginLeft: 15 }}>☹</span>
        ) : null}
        <div style={{ color: '#5f5f5f', marginTop: 3 }}>
          {moment(conversationItem.timestamp).format('ddd, MMM D, YYYY h:mm A')}
        </div>
      </div>
      {sms?.originator_number && (
        <FormHelperText style={{ position: 'absolute', bottom: 17, left: 72 }}>
          <em>{sms.originator_number}</em>
        </FormHelperText>
      )}
      {status && (
        <FormHelperText style={{ position: 'absolute', bottom: 17, right: 31 }}>
          <em>{startCase(status)}</em>
          {status === 'failed' && (
            <>
              {' '}
              <RetrySend
                media_url={sms?.attachments?.[0]?.url}
                text={sms.body}
                contact_id={sms.recipient_id}
                to={sms.recipient_number}
                from_number={sms.originator_number}
              />
            </>
          )}
        </FormHelperText>
      )}
      {conversationItem.direction === 'inbound' &&
        (devOrProd === 'Dev' || openAiAllowedAccountIDs?.[vr_account_id]) && (
          <>
            <Hidden lgUp>
              <div style={{ position: 'absolute', top: 13, right: 23 }}>
                <IconButton
                  style={{
                    padding: 5,
                    // backgroundColor: '#014c94',
                    // color: '#fff',
                  }}
                  onClick={() => onClick()}
                  variant="outlined"
                  color="secondary"
                >
                  <DudeReadingV2Icon />
                </IconButton>
              </div>
            </Hidden>
            <Hidden mdDown>
              <Button
                onClick={() => onClick()}
                style={{
                  position: 'absolute',
                  top: 17,
                  right: 27,
                  textTransform: 'none',
                }}
                variant="outlined"
                color="secondary"
              >
                <DudeReadingV2Icon style={{ marginRight: 7 }} />
                VastGPT
              </Button>
            </Hidden>
          </>
        )}
    </div>
  )
}

export default connect(
  state => ({
    businessName:
      state.AccountSettings.settings &&
      state.AccountSettings.settings.business_name,
    accountName:
      state.AccountSettings.settings && state.AccountSettings.settings.name,
    openaiinboxresponseID: Object.keys(state.data?.openaiinboxresponse || {})?.[0],
    vr_account_id:
      state.auth?.session?.idToken?.payload?.['custom:vr_account_id'],
  }),
  dispatch =>
    bindActionCreators(
      { openImageDialog, generateInboxResponse, toggleDialog, deleteEntity },
      dispatch,
    ),
)(withStyles(styles)(SMSItem))
